<template>
  <div class="row" id="socialEvaluation">
    <el-col class="col">
      <div class="form">
        <el-container>
          <el-main>
            <div class="estructura-familiar-social">
              <div style="margin-top:20px;">
                <p class="label-style">ESTRUCTURA FAMILIAR</p>
                <p style="color:#6a41bdca;font-size:12px;margin:15px 0px 0px 10px;">
                  ESTRUCTURA FAMILIAR NUCLEAR
                </p>
                <p style="color:#000000;font-size:12px;margin:4px 0px 10px 10px;">
                  NUCLEAR: Número de personas ocupadas de 14 años y mas que vivan
                  en la unidad doméstica, incluyendo el beneficiario.
                </p>
                <div
                  class="core-container"
                  v-for="( item, index ) in core"
                  :key="`core${index}`"
                  style="margin: 0 0px 20px 10px; "
                >
                  <el-form
                    :model="item"
                    :ref="`dynamicCore${index}`"
                    :rules="familyRules"
                  >
                    <div class="row-no-center">
                      <div>
                        <div class="row-no-center">
                          <el-form-item
                            prop="fullname"
                            class="large"
                            label="Nombre Completo">
                            <el-input v-model="item.fullname" :disabled="item.self"/>
                          </el-form-item>
                          <el-form-item
                            label="Fecha de nacimiento"
                            prop="birthdate"
                            v-if="item.self"
                          >
                            <el-date-picker
                              :disabled="item.self"
                              v-model="item.birthdate"
                              type="date"
                              placeholder="Fecha de nacimiento"
                              maxlength="10"
                              class="medium"
                            />
                          </el-form-item>
                          <el-form-item
                            v-if="!item.self"
                            prop="age"
                            class="medium"
                            label="Edad">
                            <el-input v-model="item.age" :disabled="item.self"/>
                          </el-form-item>
                        </div>
                        <div class="row-no-center">
                          <el-form-item
                            prop="isDependent"
                            label="Es Dependiente"
                            class="large"
                          >
                            <el-select
                              v-model="item.isDependent"
                              :disabled="item.self"
                              style="width:100%">
                              <el-option
                                label="Sí"
                                :value="true"
                              />
                              <el-option
                                label="No"
                                :value="false"
                              />
                            </el-select>
                          </el-form-item>

                          <el-form-item
                            prop="hasDisability"
                            label="Tiene Discapacidad"
                            class="medium"
                          >
                            <el-select
                              v-model="item.hasDisability"
                              :disabled="item.self"
                              style="width:100%">
                              <el-option
                                label="Sí"
                                :value="true"
                              />
                              <el-option
                                label="No"
                                :value="false"
                              />
                            </el-select>
                          </el-form-item>
                        </div>
                        <div class="row-no-center">
                          <el-form-item
                            prop="maritalStatus"
                            label="Estado civil"
                            class="large"
                          >
                            <el-select
                              v-model="item.maritalStatus"
                              :disabled="item.self"
                              style="width:100%">
                              <el-option
                                v-for="i in maritalStatusOpt"
                                :key="i.value"
                                :label="i.label"
                                :value="i.value"
                              />
                            </el-select>
                          </el-form-item>
                          <el-form-item
                            prop="relationship"
                            class="medium"
                            label="Parentesco">
                            <el-input v-model="item.relationship" :disabled="item.self" />
                          </el-form-item>
                        </div>
                        <div class="row-no-center">
                          <el-form-item
                            prop="occupation"
                            class="large"
                            label="Ocupación">
                            <el-input
                              v-model="item.occupation"
                              :disabled="item.self"
                            />
                          </el-form-item>

                          <el-form-item
                            prop="monthlyContribution"
                            class="medium"
                            label="Aportación mensual en pesos"
                          >
                            <el-input v-model="item.monthlyContribution" />
                          </el-form-item>
                        </div>
                      </div>
                      <div class="removeCont" v-if="!item.self">
                        <div @click="removeCore(index)" class="remove row">
                          <span>x</span>
                        </div>
                        <span class="btnText">Remover miembro familiar</span>
                      </div>
                    </div>
                  </el-form>
                </div>
                <div
                  class="row-no-center"
                  style="display: flex; flex-direction: column; "
                >
                  <div
                    class="up"
                    style="display: flex; flex-direction: row;"
                  >
                    <div @click="addCore" class="add row" style=" background: #6a41bdca">
                      <span>&#43;</span>
                    </div>
                    <span class="btnText">Agregar un miembro familiar</span>
                  </div>
                  <div
                    class="wide-container"
                    style="margin-top:24px;"
                  >
                    <p
                    class="label-style"
                    >
                      ESTRUCTURA FAMILIAR EXTENDIDA
                    </p>
                    <p style="color:#000000;font-size:12px;margin:10px 0px 10px 10px;">
                      Extendida: Número de personas ocupadas de 14 años y mas que apoyen a
                      la economía de la unidad doméstica.
                    </p>
                    <div
                      v-for="( item, index ) in wide"
                      :key="`wide${index}`"
                      style="margin-bottom:5px;"
                    >
                      <el-form
                        :model="item"
                        :ref="`dynamicWide${index}`"
                        :rules="familyRules"
                      >
                        <div class="row-no-center">
                          <div>
                            <div class="row-no-center">
                              <el-form-item
                                prop="fullname"
                                class="large"
                                label="Nombre Completo"
                              >
                                <el-input v-model="item.fullname" />
                              </el-form-item>

                              <!-- <el-form-item
                                label="Fecha de nacimiento"
                                prop="birthdate"
                              >
                                <el-date-picker
                                  :disabled="item.self"
                                  v-model="item.birthdate"
                                  type="date"
                                  placeholder="Fecha de nacimiento"
                                  maxlength="10"
                                  class="medium"
                                />
                              </el-form-item> -->
                              <el-form-item
                                prop="age"
                                class="medium"
                                label="Edad">
                                <el-input v-model="item.age" :disabled="item.self"/>
                              </el-form-item>
                            </div>

                            <div class="row-no-center">
                              <el-form-item
                                prop="isDependent"
                                label="Es Dependiente"
                                class="large"
                              >
                                <el-select
                                  v-model="item.isDependent"
                                  :disabled="item.self"
                                  style="width:100%">
                                  <el-option
                                    label="Sí"
                                    :value="true"
                                  />
                                  <el-option
                                    label="No"
                                    :value="false"
                                  />
                                </el-select>
                              </el-form-item>

                              <el-form-item
                                prop="hasDisability"
                                label="Tiene Discapacidad"
                                class="medium"
                              >
                                <el-select
                                  v-model="item.hasDisability"
                                  :disabled="item.self"
                                  style="width:100%">
                                  <el-option
                                    label="Sí"
                                    :value="true"
                                  />
                                  <el-option
                                    label="No"
                                    :value="false"
                                  />
                                </el-select>
                              </el-form-item>
                            </div>

                            <div class="row-no-center">
                              <el-form-item
                                prop="maritalStatus"
                                label="Estado civil"
                                class="large"
                              >
                                <el-select
                                  v-model="item.maritalStatus"
                                  :disabled="item.self"
                                  style="width:100%">
                                  <el-option
                                    v-for="i in maritalStatusOpt"
                                    :key="i.value"
                                    :label="i.label"
                                    :value="i.value"
                                  />
                                </el-select>
                              </el-form-item>

                              <el-form-item
                                prop="relationship"
                                class="medium"
                                label="Parentesco">
                                <el-input v-model="item.relationship" :disabled="item.self" />
                              </el-form-item>
                            </div>

                            <div class="row-no-center">
                              <el-form-item prop="occupation" class="large" label="Ocupación">
                                <el-input v-model="item.occupation" />
                              </el-form-item>
                              <el-form-item
                                prop="monthlyContribution"
                                class="medium"
                                label="Aportación mensual en pesos"
                              >
                                <el-input v-model="item.monthlyContribution" />
                              </el-form-item>
                              <!-- <el-form-item
                                prop="otherContribution"
                                class="medium"
                                label="Otros ingresos"
                              >
                                <el-input v-model="item.otherContribution" />
                              </el-form-item> -->
                            </div>
                          </div>
                          <div class="removeCont">
                            <div @click="removeWide(index)" class="remove row">
                              <span>x</span>
                            </div>
                            <span class="btnText">Remover miembro familiar</span>
                          </div>
                        </div>
                      </el-form>
                    </div>
                    <div class="row-no-center">
                      <div @click="addWide" class="add row"  style="background: #6a41bdca;">
                        <span>&#43;</span>
                      </div>
                      <span class="btnText">Agregar un miembro familiar</span>
                    </div>
                    <el-button
                    type="primary"
                    size="small"
                    style="margin-top:24px; background: #6a41bdca; bolder-color: #6a41bdca;"
                    @click="presubmit()"
                    >
                      Guardar Estrutura Familiar
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </el-main>
        </el-container>
      </div>
    </el-col>
  </div>
</template>

<script>
import lodash from 'lodash';
import optionsMixin from '../../views/evaluations/SocioEconomic/mixin/options';

export default {
  data() {
    const isDecimal = (rule, value, cb) => {
      const regexp = /^[0-9]+([,.][0-9]+)?$/g;
      if (value && !regexp.test(value)) {
        return cb(new Error('El campo debe ser un numero decimal.'));
      }
      return cb();
    };
    return {
      total: null,
      docsVisible: false,
      label: 'Por favor llene los datos requeridos para completar la Evaluación',
      createdAt: '',
      appointmentId: '',
      BeforeAppointments: '',
      initialForm: {},
      isFirstEvaluation: true,
      core: [],
      initialCore: [],
      wide: [],
      initialWide: [],
      familyRules: {
        fullname: [
          {
            required: true,
            message: 'El campo es requerido',
          },
        ],
        relationship: [
          {
            required: true,
            message: 'El campo es requerido',
          },
        ],
        age: [
          {
            required: true,
            message: 'El campo es requerido',
          },
        ],
        occupation: [
          {
            required: true,
            message: 'El campo es requerido',
          },
        ],
        monthlyContribution: [
          {
            validator: isDecimal,
          },
        ],
        otherContribution: [
          {
            validator: isDecimal,
          },
        ],
      },
      loadingService: null,
      loading: false,
      hasSelfOccupation: false,
      anteriorValue: 0,
      form: {
        fullName: '',
        relationship: '',
        occupation: 'NADA',
        monthlyContribution: '',
        age: '',
      },
      rules: {
        expenseWater: [
          {
            validator: isDecimal,
          },
        ],
        expenseLight: [
          {
            validator: isDecimal,
          },
        ],
        expensePhone: [
          {
            validator: isDecimal,
          },
        ],
        expenseCellPhone: [
          {
            validator: isDecimal,
          },
        ],
        expenseGas: [
          {
            validator: isDecimal,
          },
        ],
        expenseFood: [
          {
            validator: isDecimal,
          },
        ],
        expenseHouseSupplies: [
          {
            validator: isDecimal,
          },
        ],
        expenseHealth: [
          {
            validator: isDecimal,
          },
        ],
        expenseSupport: [
          {
            validator: isDecimal,
          },
        ],
        expenseEducation: [
          {
            validator: isDecimal,
          },
        ],
        expenseRent: [
          {
            validator: isDecimal,
          },
        ],
        expenseTransport: [
          {
            validator: isDecimal,
          },
        ],
        expenseCreditCard: [
          {
            validator: isDecimal,
          },
        ],
        expenseOther: [
          {
            validator: isDecimal,
          },
        ],

      },
    };
  },
  mixins: [optionsMixin],
  computed: {
    sumAportaciones() {
      let income = 0;
      income += this.core
        .reduce((prev, curr) => prev
        + parseFloat(curr.monthlyContribution ?? 0), 0);
      income += this.wide.reduce((prev, curr) => prev
        + parseFloat(curr?.monthlyContribution ?? 0) + parseFloat(curr?.otherContribution ?? 0), 0);
      this.sendInformation(income);
      return income;
    },
  },
  methods: {
    sendInformation(income) {
      this.$emit('total-income', income);
    },
    format() {
      return {
        patient: this.form.patient,
      };
    },
    getDiff(obj1 = {}, obj2 = {}, diff = [], keyMap = '') {
      Object.keys(obj1).forEach((key) => {
        if (typeof obj2[key] === 'object' && obj2[key] !== null && !Array.isArray(obj2[key])) {
          const diffR = this.getDiff(obj1[key], obj2[key], diff, `${keyMap}${key}.`);
          diff.concat(diffR);
        } else if (!lodash.isEqual(obj1[key], obj2[key])) {
          let keyMapFormatted = `${keyMap}${key}`;
          keyMapFormatted = keyMapFormatted.replace(/[0-9]$/g, '');
          keyMapFormatted = keyMapFormatted[keyMapFormatted.length - 1] === '.'
            ? keyMapFormatted.slice(0, -1) : keyMapFormatted;
          diff.push(keyMapFormatted);
        }
      });
      return diff;
    },
    generateEmptyCore() {
      return {
        id: 0,
        fullname: null,
        relationship: null,
        occupation: null,
        monthlyContribution: null,
        age: null,
      };
    },
    generateEmptyWide() {
      return {
        id: 0,
        fullname: 'Miguel C.',
        relationship: 'AMIGO',
        occupation: 'DESARROLLADOR',
        monthlyContribution: 3500,
        otherContribution: null,
        age: 15,
      };
    },
    attach() {},
    validateCore() {
      let validCount = 0;
      const formAmount = this.core.length;
      this.core.forEach((item, index) => {
        this.$refs[`dynamicCore${index}`][0].validate((isValid) => {
          if (isValid) {
            validCount += 1;
          }
        });
      });
      if (validCount === formAmount) {
        return true;
      }
      return false;
    },
    addWide() {
      this.wide.push(this.generateEmptyWide());
    },
    validateWide() {
      let validCount = 0;
      const formAmount = this.wide.length;
      this.wide.forEach((item, index) => {
        this.$refs[`dynamicWide${index}`][0].validate((isValid) => {
          if (isValid) {
            validCount += 1;
          }
        });
      });
      if (validCount === formAmount) {
        return true;
      }
      return false;
    },
    addCore() {
      this.core.push(this.generateEmptyCore());
    },
    removeCore(index) {
      if (this.core.length !== 0) {
        this.core.splice(index, 1);
      }
    },
    coreChanged() {
      const result = {
        deleted: this
          .initialCore.filter((ic) => !this.core.some((c) => c.id === ic.id)).map((x) => x.id),
        changed: [],
        new: this.core.filter((ic) => !this.initialCore.some((c) => c.id === ic.id)),
      };
      for (let i = 0; i < this.core.length; i++) {
        const curr = this.core[i];
        const prev = this.initialCore.find((x) => x.id === curr.id);
        const diff = this.getDiff(prev, curr);
        if (diff.length) {
          result.changed.push(curr);
        }
      }
      return result;
    },
    wideChanged() {
      const result = {
        deleted: this
          .initialWide.filter((ic) => !this.wide.some((c) => c.id === ic.id)).map((x) => x.id),
        changed: [],
        new: this.wide.filter((ic) => !this.initialWide.some((c) => c.id === ic.id)),
      };
      for (let i = 0; i < this.wide.length; i++) {
        const curr = this.wide[i];
        const prev = this.initialWide.find((x) => x.id === curr.id);
        const diff = this.getDiff(prev, curr);
        if (diff.length) {
          result.changed.push(curr);
        }
      }
      return result;
    },
    removeWide(index) {
      if (this.wide.length !== 0) {
        this.wide.splice(index, 1);
      }
    },
    beforeSubmit() {
      if (this.validateCore() && this.validateWide()) {
        this.$refs.refId.validate((isValid) => {
          if (isValid) {
            this.presubmit();
          }
        });
      }
    },
    async presubmit() {
      try {
        this.loading = true;
        const requests = [];
        const data = this.format();
        const { id: patientId } = this.$route.params;
        if (this.isFirstEvaluation) {
          requests.concat(this.core.map((item) => this.axios.post(`patient/newsocial/family/core/${patientId}`, {
            ...item,
            monthlyContribution: parseFloat(item.monthlyContribution),
          })));
          requests.concat(this.wide.map((item) => this.axios.post(`patient/newsocial/family/wide/${patientId}`, {
            ...item,
            monthlyContribution: parseFloat(item.monthlyContribution),
            otherContribution: parseFloat(item.otherContribution),
          })));
          const response = await Promise.all(requests);
          if (response.length) {
            await this.axios.post(`patient/changelog/${patientId}`, {
              title: 'EVALUACIÓN SOCIOECONÓMICA',
              message: 'Se ha agregado evaluación socioeconómica',
            });
          }
          this.$notify({
            type: 'success',
            title: '¡Éxito!',
            message: 'Se ha agregado evaluación socioeconómica',
          });
          // this.submitBathroom();
          this.loading = false;
          // setTimeout(() => {
          //   window.location.reload();
          // });
        } else {
          let message;
          const coreChanges = this.coreChanged();
          const coreChanged = coreChanges.deleted.length
            || coreChanges.changed.length || coreChanges.new.length;
          if (coreChanged) {
            requests.concat(coreChanges.deleted.map((item) => this
              .axios.delete(`patient/newsocial/family/core/${item}/${patientId}`)));
            requests.concat(coreChanges.new.map(
              (item) => this.axios.post(`patient/newsocial/family/core/${patientId}`, {
                ...item,
                monthlyContribution: parseFloat(item.monthlyContribution),
              }),
            ));
            requests.concat(coreChanges.changed.map(
              (item) => this.axios.put(`patient/newsocial/family/core/${item.id}`, {
                ...item,
                monthlyContribution: parseFloat(item.monthlyContribution),
              }),
            ));
            message = 'Se modificó la estructura familiar nuclear';
            this.$notify({
              message,
              type: 'success',
              title: 'EVALUACIÓN SOCIOECONÓMICA',
            });
          }
          const wideChanges = this.wideChanged();
          const wideChanged = wideChanges.deleted.length
            || wideChanges.changed.length || wideChanges.new.length;
          if (wideChanged) {
            try {
              requests.concat(wideChanges.deleted.map((item) => this.axios
                .delete(`patient/newsocial/family/wide/${item}/${patientId}`)));
              requests.concat(wideChanges.new.map(
                (item) => this.axios.post(`patient/newsocial/family/wide/${patientId}`, {
                  ...item,
                  monthlyContribution: parseFloat(item.monthlyContribution),
                  otherContribution: parseFloat(item.otherContribution),
                }),
              ));
              requests.concat(wideChanges.changed.map(
                (item) => this.axios.put(`patient/newsocial/family/wide/${item.id}`, {
                  ...item,
                  monthlyContribution: parseFloat(item.monthlyContribution),
                  otherContribution: parseFloat(item.otherContribution),
                }),
              ));
              message = 'Se modificó la estructura familiar amplia';
              this.$notify({
                message,
                type: 'success',
                title: 'EVALUACIÓN SOCIOECONÓMICA',
              });
            } catch (error) {
              this.loading = false;
            }
          }
          if (coreChanged && wideChanged) {
            message = 'Se modificaron las estructuras familiares';
            requests.push(this.axios.post(`patient/changelog/${patientId}`, {
              patient: data.patient,
              title: 'EVALUACIÓN SOCIOECONÓMICA',
              message,
            }));
          }
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    async getData(patientId) {
      try {
        const responseAppointments = await this.axios.get(`patient/social/getAppointmentSocial/${patientId}`);
        if (responseAppointments.data) {
          this.appointmentId = responseAppointments.data[0].id;
        }
        // FALTA DECLARA EL appointmentId
        const response = await this.axios.get(`patient/social/details/${patientId}`);

        if (response.data) {
          const { data } = response;
          this.evaluationId = data.id;
          this.form = data;
          this.createdAt = data?.createdAt;
          this.core = data.familyCore;
          this.wide = data.familyWide;
          this.isFirstEvaluation = false;

          const formClone = JSON.parse(JSON.stringify(this.form));
          this.initialForm = formClone;
          const coreClone = JSON.parse(JSON.stringify(this.core));
          this.initialCore = coreClone;

          const wideClone = JSON.parse(JSON.stringify(this.wide));
          this.initialWide = wideClone;
          if (this.core.length) {
            const self = this.core.find((x) => x.self);
            if (self) {
              this.core = [self, ...this.core.filter((x) => !x.self)];
            } else {
              this.core[0].self = true;
            }
          } else {
            const response2 = await this.axios.get(`patient/profile/${patientId}`);
            const response3 = await this.axios.get(`patient/info/${patientId}`);
            if (response2 && response3) {
              this.core.push({
                self: true,
                fullname: `${response3.data.firstName} ${response3.data.lastName}`,
                relationship: 'N/A',
                occupation: 'SIN OCUPACIÓN',
                monthlyContribution: null,
                birthdate: response3.data.birthdate,
                maritalStatus: response2.data.maritalStatus,
              });
            }
          }
        } else {
          this.isFirstEvaluation = true;
          const response2 = await this.axios.get(`patient/profile/${patientId}`);
          const response3 = await this.axios.get(`patient/info/${patientId}`);
          if (response2 && response3) {
            this.core.push({
              self: true,
              fullname: `${response3.data.firstName} ${response3.data.lastName}`,
              relationship: 'N/A',
              occupation: response2.data.occupation,
              monthlyContribution: null,
              birthdate: response3.data.birthdate,
              maritalStatus: response2.data.maritalStatus,
            });
          }
        }
        this.form.patient = patientId;
      } catch (error) {
        //
      }
    },
    async getAppointmentsSocial() {
      try {
        const response = await this.axios.get(`patient/social/getAppointmentSocial/${this.$route.params.id}`);
        if (response.data) {
          this.appointmentId = response.data[0].id;
        }
      } catch (error) {
        // this.$errorNotify(error);
      }
    },
  },
  async created() {
    const { id } = this.$route.params;
    this.form.patient = id;
    await this.getData(id);
    this.getAppointmentsSocial();
  },
  watch: {
    loading(val) {
      if (val && !this.loadingService) {
        this.loadingService = this.$loading({
          fullscreen: true,
          lock: true,
          text: 'Cargando',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        });
      } else if (this.loadingService) {
        this.loadingService.close();
        this.loadingService = null;
      }
    },
  },
};
</script>

<style lang="scss">
@import '../../views/evaluations/SocioEconomic/styles/style.scss';
el-main {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
</style>
<style lang="scss" scoped>
  @import '../../views/evaluations/SocioEconomic/styles/style-scoped.scss';
.core-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
</style>
